export const textTruncate = (text, length, ending) => {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (text.length > length) {
    return text.substring(0, length - ending.length) + ending;
  } else {
    return text;
  }
};

export const match = (term, array, key) => {
  const reg = new RegExp(term.split('').join('.*'), 'i');
  return array.filter(item => item[key] && item[key].match(reg));
};

export const formatRuntimeMinutes = (totalMins) => {
  if (!totalMins) return '--';
  const hours = Math.floor(totalMins / 60);
  const minutes = totalMins % 60;
  const hStr = hours > 0 ? `${hours} hr` : '';
  const mStr = minutes > 0 ? `${minutes} min` : '';
  return [hStr, mStr].filter(Boolean).join(' ');
};
